(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/bankid-spinner.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/bankid-spinner.js');
'use strict';

const Button = svs.ui.ReactButton;
const BankidFooter = svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify.components.BankidFooter;
const LoaderPanel = svs.accountservicesReact.deposit.swedbankExpress.sharedComponents.LoaderPanel;
const BankidSpinner = _ref => {
  let onCancel = _ref.onCancel,
    _ref$isDeposit = _ref.isDeposit,
    isDeposit = _ref$isDeposit === void 0 ? false : _ref$isDeposit,
    _ref$isConsentSelectB = _ref.isConsentSelectBankWait,
    isConsentSelectBankWait = _ref$isConsentSelectB === void 0 ? false : _ref$isConsentSelectB;
  const handleCancel = () => {
    onCancel();
  };
  return React.createElement("div", {
    className: "margin-top-2 align-center"
  }, React.createElement("div", null, isConsentSelectBankWait ? 'Hämtar dina bankkonton...' : 'Väntar på identifiering...'), React.createElement(LoaderPanel, null), React.createElement("div", {
    className: "padding-top-4"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-4",
    onClick: handleCancel,
    transparent: true
  }, "Avbryt")), React.createElement(BankidFooter, {
    isDeposit: isDeposit
  }));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify.BankidSpinner = BankidSpinner;

 })(window);